import { useRentalManagerUserPropertyMultiplexWebApiHandler_details } from '@zg-rentals/ts-rental-manager-api-beta-client-react-query';

import useMultiplexBuildingSessionId from './useMultiplexBuildingSessionId';

/**
 * Fetches multiplex building-session property details for the modular listing flow.
 */
const useMultiplexDetails = ({ enabled = true }: { enabled?: boolean } = {}) => {
  const { multiplexBuildingSessionId } = useMultiplexBuildingSessionId();

  const { data, error, isFetching } = useRentalManagerUserPropertyMultiplexWebApiHandler_details(
    { multiplexBuildingSessionId: multiplexBuildingSessionId ?? '' },
    {
      enabled: enabled && Boolean(multiplexBuildingSessionId),
      meta: {
        tags: multiplexBuildingSessionId
          ? ['multiplexBuildingSessionDetails', multiplexBuildingSessionId]
          : ['multiplexBuildingSessionDetails'],
        context: {
          api: 'useRentalManagerUserPropertyMultiplexWebApiHandler_details',
          details: 'useMultiplexDetails',
        },
      },
    },
  );

  return {
    data,
    isFetching,
    error,
  };
};

export default useMultiplexDetails;
